import React from "react";

const BillingContent = ({
  billingContent,
  billingContentData,
  paymentContent,
  selectedSections,
}: {
  billingContent: any;
  billingContentData: any;
  paymentContent: any;
  selectedSections: { [key: string]: boolean };
}) => {
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse" as const,
    fontSize: "12px",
    border: "1px solid #ddd",
  };

  const thStyle = {
    borderRight: "1px solid #ddd",
    borderBottom: "1px solid #ddd",
    padding: "4px",
    fontWeight: "bold",
  };

  const thLastStyle = {
    borderRight: "none",
    borderBottom: "1px solid #ddd",
    padding: "4px",
    fontWeight: "bold",
  };

  const tdStyle = {
    borderRight: "1px solid #ddd",
    padding: "4px",
  };

  const tdLastStyle = {
    borderRight: "none",
    padding: "4px",
  };

  const numberToWords = (num: number): string => {
    if (!num) return "Zero Only";
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const convert = (n: number): string => {
      if (n < 20) return ones[n];
      if (n < 100)
        return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
      if (n < 1000)
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " " + convert(n % 100) : "")
        );
      if (n < 100000)
        return (
          convert(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 ? " " + convert(n % 1000) : "")
        );
      if (n < 10000000)
        return (
          convert(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 ? " " + convert(n % 100000) : "")
        );
      return (
        convert(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 ? " " + convert(n % 10000000) : "")
      );
    };
    return convert(Math.floor(num)) + " Only";
  };

  return (
    <div>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thStyle, width: "40px", textAlign: "center" }}>
              SR #
            </th>
            <th style={{ ...thStyle, textAlign: "left" }}>ITEM</th>
            <th style={{ ...thStyle, textAlign: "right" }}>QTY</th>
            <th style={{ ...thStyle, textAlign: "right" }}>PRICE ₹</th>
            <th style={{ ...thStyle, textAlign: "right" }}>DISCOUNT</th>
            <th style={{ ...thLastStyle, textAlign: "right" }}>AMOUNT ₹</th>
          </tr>
        </thead>
        <tbody>
          {billingContent?.map((item: any) => (
            <tr key={item.billingDetailId}>
              <td style={{ ...tdStyle, textAlign: "center", width: "5%" }}>
                {item?.rowIndex}
              </td>
              <td style={{ ...tdStyle, width: "43%" }}>
                <b>{item.itemIdLabel}</b>
                {item.itemDescription && <div>{item.itemDescription}</div>}
              </td>
              <td style={{ ...tdStyle, textAlign: "right", width: "13%" }}>
                {item.quantity?.toFixed(2)}
              </td>
              <td style={{ ...tdStyle, textAlign: "right", width: "13%" }}>
                {item.price?.toFixed(2)}
              </td>
              <td style={{ ...tdStyle, textAlign: "right", width: "13%" }}>
                {item.discountType}
                {item.discountValue?.toFixed(2)}
              </td>
              <td
                style={{
                  ...tdLastStyle,
                  textAlign: "right",
                  fontWeight: "bold",
                  width: "13%",
                }}>
                {item.amount?.toFixed(2)}
              </td>
            </tr>
          ))}
          {/* 3 blank rows */}
          {[...Array(3)].map((_, i) => (
            <tr key={`blank-${i}`}>
              <td style={tdStyle}>&nbsp;</td>
              <td style={tdStyle}>&nbsp;</td>
              <td style={tdStyle}>&nbsp;</td>
              <td style={tdStyle}>&nbsp;</td>
              <td style={tdStyle}>&nbsp;</td>
              <td style={tdLastStyle}>&nbsp;</td>
            </tr>
          ))}
          {/* Total quantity row */}
          <tr>
            <td style={tdStyle}>&nbsp;</td>
            <td style={tdStyle}>&nbsp;</td>
            <td style={{ ...tdStyle, textAlign: "right", fontWeight: "bold" }}>
              {billingContent
                ?.reduce(
                  (sum: number, item: any) => sum + (item.quantity || 0),
                  0,
                )
                .toFixed(2)}
            </td>
            <td style={tdStyle}>&nbsp;</td>
            <td style={tdStyle}>&nbsp;</td>
            <td style={tdLastStyle}>&nbsp;</td>
          </tr>
        </tbody>
      </table>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "0px",
        }}>
        <table
          style={{
            width: "100%",
            fontSize: "12px",
            borderCollapse: "collapse",
            border: "1px solid #ddd",
            borderTop: "none",
          }}>
          <colgroup>
            <col style={{ width: "74%" }} />
            <col style={{ width: "26%" }} />
          </colgroup>

          <tbody>
            {[
              {
                label: "Sub Total:",
                value: billingContentData?.subTotal?.toFixed(2),
              },
              {
                label: "Discount:",
                value: billingContentData?.billDiscountValue?.toFixed(2),
              },
              {
                label: "Taxable Amount:",
                value: billingContentData?.taxableAmount?.toFixed(2),
              },
              {
                label: "Tax:",
                value: (
                  billingContentData?.centralTaxAmount +
                  billingContentData?.stateTaxAmount +
                  billingContentData?.integratedTaxAmount
                )?.toFixed(2),
              },
              {
                label: `${billingContentData?.adjustmentLabel}:`,
                value: billingContentData?.adjustmentValue?.toFixed(2),
              },
              {
                label: "Total:",
                value: billingContentData?.totalBillAmount?.toFixed(2),
              },
              {
                label: "Round off:",
                value: billingContentData?.roundOff?.toFixed(2),
              },
              {
                label: "Grand Amount(₹):",
                value: billingContentData?.finalGrandTotalAmount?.toFixed(2),
                isGrand: true,
              },
            ].map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    borderRight: "1px solid #ddd",
                    borderTop: item.isGrand ? "1px solid #ddd" : "none",
                    padding: "4px",
                    textAlign: "right",
                    fontWeight: "bold",
                  }}>
                  {item.isGrand ? <b>{item.label}</b> : item.label}
                </td>

                <td
                  style={{
                    borderTop: item.isGrand ? "1px solid #ddd" : "none",
                    padding: "4px",
                    textAlign: "right",
                    fontWeight: "bold",
                  }}>
                  {item.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          marginTop: "6px",
          fontSize: "13px",
          fontWeight: "bold",
        }}>
        Amount in Words:{" "}
        {numberToWords(Number(billingContentData?.finalGrandTotalAmount))}
      </div>

      {paymentContent && paymentContent.length > 0 && (
        <>
          <div
            style={{
              marginTop: "10px",
              fontSize: "13px",
              fontWeight: "bold",
            }}>
            Payment History
          </div>
          <table style={{ ...tableStyle, marginTop: "4px" }}>
            <thead>
              <tr>
                <th style={{ ...thStyle, textAlign: "left" }}>Receipt Date</th>
                <th style={{ ...thStyle, textAlign: "left" }}>Particulars</th>
                <th style={{ ...thLastStyle, textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {paymentContent.map((pay: any, idx: number) => {
                const refTypeLabel =
                  pay.refType === "ADJUST_REFERENCE"
                    ? "Adv."
                    : pay.refType === "AGAINST_REFERENCE"
                      ? "Agt. Inv."
                      : pay.refType;

                const particulars = `Rcpt - ${refTypeLabel} (${pay.paymentMode} - ${pay.refNo})`;

                const refDateFormatted = pay.refDate
                  ? new Date(pay.refDate)
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .join("-")
                  : "";

                return (
                  <tr key={pay.refId ?? idx}>
                    <td style={tdStyle}>{refDateFormatted}</td>
                    <td style={tdStyle}>{particulars}</td>
                    <td style={{ ...tdLastStyle, textAlign: "right" }}>
                      {pay.amount?.toFixed(2)}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td style={tdStyle}>&nbsp;</td>
                <td style={tdStyle}>&nbsp;</td>
                <td
                  style={{
                    ...tdLastStyle,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}>
                  {paymentContent
                    .reduce(
                      (sum: number, p: any) => sum + (p.amount || 0),
                      0,
                    )
                    .toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
      <div
        style={{
          marginTop: "6px",
          fontSize: "13px",
          fontWeight: "bold",
        }}
      >
        Pending Balance Due :{" "}
        {(
          Number(billingContentData?.finalGrandTotalAmount ?? 0) -
          (paymentContent ?? []).reduce(
            (sum: number, p: any) =>
              sum + Number(p?.voucherTotalAmount ?? 0),
            0
          )
        ).toFixed(2)}
      </div>

    </div>
  );
};

export default BillingContent;
